import { Buffer } from 'safe-buffer';
import cryptoJS from 'crypto-js';

const MAX_BYTES = 65536;
const MAX_UINT32 = 4294967295;
const crypto = (window as any).crypto || (window as any).msCrypto;

export class SecurityHelper {
    public static sha256(msg: string): string {
        return cryptoJS.SHA256(msg).toString(cryptoJS.enc.Base64);
    }

    public static getTokenClaim(accessToken: string | null | undefined, claim: string): string | null {
        if (!accessToken) {
            return null;
        }

        const payload = accessToken.split('.')[1];
        if (!payload) {
            return null;
        }

        try {
            const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
            const decoded = JSON.parse(decodeURIComponent(escape(atob(normalized))));
            const value = decoded[claim];

            return value === undefined || value === null ? null : String(value);
        } catch {
            return null;
        }
    }

    public static getRandomBytes(size: number): Buffer {
        if (crypto && crypto.getRandomValues) {
            return this.getRandomBytesNewBrowser(size);
        } else {
            return this.getRandomBytesOldBrowser(size);
        }
    }

    private static getRandomBytesOldBrowser(size) {
        if (size > MAX_UINT32) { throw new RangeError('requested too many random bytes'); }

        const bytes = new Buffer(size);
        for (let round = 0; round < 20; round++) {
            for (let i = 0; i < bytes.length; i++) {
                if (round) {
                    bytes[i] ^= parseInt((256 * Math.random()).toString(), 2);
                } else {
                    bytes[i] = parseInt((256 * Math.random()).toString(), 2);
                }
            }
        }

        return bytes;
    }

    private static getRandomBytesNewBrowser(size: number) {
        if (size > MAX_UINT32) { throw new RangeError('requested too many random bytes'); }

        const bytes = Buffer.allocUnsafe(size);

        if (size > 0) {  // getRandomValues fails on IE if size == 0
            if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
                // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
                for (let generated = 0; generated < size; generated += MAX_BYTES) {
                    // buffer.slice automatically checks if the end is past the end of
                    // the buffer so we don't have to here
                    crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
                }
            } else {
                crypto.getRandomValues(bytes);
            }
        }

        return bytes;
    }
}
